import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { ApiUriContants } from "../_constants/apiUriConstants";
import { BehaviorSubject } from "rxjs";
@Injectable({ providedIn: "root" })
export class UserService {
  public isLocalStorageUpdated: BehaviorSubject<boolean> = new BehaviorSubject<
    boolean
  >(false);
  constructor(private httpService: HttpService) { }
  fetchUserList(params = { showAll: false }) {
    const url = `${ApiUriContants.user}getallusers`;
    return this.httpService.get(url, params);
  }
  fetchUserListById(user_id:any) {
    const url = `${ApiUriContants.user}getuserbyid`;
    return this.httpService.get(url, { strUId: user_id });
  }
  fetchUniqueUserName(username:any) {
    const url = `${ApiUriContants.user}availableusername`;
    return this.httpService.get(url, { Username: username });
  }

  addUser(User:any) {
    const url = `${ApiUriContants.user}createuser`;
    return this.httpService.post(url, User);
  }
  editUser(User:any) {
    const url = `${ApiUriContants.user}updateuser`;
    return this.httpService.put(url, User);
  }
  updateProfile(User:any) {
    const url = `${ApiUriContants.user}UpdateUser`;
    return this.httpService.put(url, User);
  }
  statusChange(id:any, isActive = false) {
    const url = `${ApiUriContants.account}updateuserstatus`;
    return this.httpService.delete(url, { userId: id, isActive: isActive });
  }

  getMenuList(id:any) {
    const url = `${ApiUriContants.user}getmenu`;
    return this.httpService.get(url, { userId: id });
  }
  getAboutDetails() {
    const url = `${ApiUriContants.about}getaboutdetails`;
    return this.httpService.get(url);
  }
  
  changePassword(params:any) {
    const url = `${ApiUriContants.user}changepassword`;
    // Passwords go in the body, never the query string - URLs end up in access logs,
    // proxy logs and browser history.
    return this.httpService.post(url, params);
  }
  unlockUser(params:any) {
    const url = `${ApiUriContants.user}unlockuser`;
    return this.httpService.put(url, params);
  }

  GeoOneLoginEmail(ssoToken: string) {
    const url = `${ApiUriContants.account}GeoOneLoginEmail?ssotoken=${ssoToken}`;  // Pass ssotoken as a query parameter
    return this.httpService.get(url);  // Use GET request since it's a query parameter
}

getUserVOSSOToken(params:any) {
  const url = `${ApiUriContants.account}generatessotoken`;
  return this.httpService.post(url, {}, params);
}

addUserMapping(User:any) {
    const url = `${ApiUriContants.user}createusermapping`;
    return this.httpService.post(url, User);
  }
  
   editUserMapping(User:any) {
    const url = `${ApiUriContants.user}updateusermapping`;
    return this.httpService.put(url, User);
  }
}
